import { styled } from 'styled-components';

// Wrapper around a single checklist item
export const Li = styled.li`
  height: var(--spacing-large);
  margin-bottom: var(--spacing-tiny);
`;
